.cabecera { display: flex; justify-content: space-between; align-items: center; gap: var(--s-5); }
.cuerpo { display: flex; flex-direction: column; gap: var(--s-3); }
.cuerpo > .cabecera { margin-bottom: var(--s-3); }
.botones { display: flex; gap: var(--s-4); flex-wrap: wrap; margin-top: var(--s-4); }
.aviso { align-self: flex-start; }

.franja { display: flex; align-items: center; justify-content: space-between; gap: var(--s-5); padding: var(--s-5) var(--s-6); border-radius: var(--r-md); background: var(--accent-50); border: 1px solid var(--accent-100); }
.franjaTexto { display: flex; flex-direction: column; gap: var(--s-2); min-width: 0; flex: 1; }
.franja .botones { margin-top: 0; flex-shrink: 0; }

.pedido { display: flex; flex-direction: column; gap: var(--s-3); margin-top: var(--s-4); }
.botonesPedido { display: flex; gap: var(--s-3); flex-wrap: wrap; align-items: center; }
